<template>
  <div
      class="px-7 pt-[2.188rem] relative h-full w-full"
  >
    <img src="@assets/img/dashboard/images/party-left.png" class='absolute top-0 left-0 pointer-events-none w-[5.469rem] z-[-1]' alt="">
    <img src="@assets/img/dashboard/images/party-middle.png" class='absolute top-0 left-0 right-0 mx-auto pointer-events-none h-[2.403rem] z-[-1]' alt="">
    <img src="@assets/img/dashboard/images/party-right.png" class='absolute top-0 right-0 pointer-events-none w-[5.469rem] z-[-1]' alt="">
    <slot></slot>
  </div>
</template>